import { Crate } from '@perch-labs/shrike';
import styled from 'styled-components';
import { RowChild } from 'styles';

export const AddProofDocRowChild = styled(RowChild).attrs({
  direction: 'column',
  style: { paddingTop: '24px', paddingLeft: '24px', paddingRight: '24px' },
  alignItems: 'left',
})``;

export const StyledCrate = styled(Crate)`
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  min-height: 270px;

  @media ${props => props.theme.media.tabletLandscapeDown} {
    max-width: 784px;
  }

  @media ${props => props.theme.media.desktopUp} {
    width: 784px;
  }
`;

export const StyledLegend = styled.legend`
  margin-top: 16px;
`;
